export function getAvatarOverflowLayout(memberCount: number, maxVisible: number) {
  if (maxVisible <= 0) {
    return {
      visibleCount: 0,
      overflowCount: Math.max(0, memberCount),
    };
  }

  if (memberCount <= maxVisible) {
    return {
      visibleCount: memberCount,
      overflowCount: 0,
    };
  }

  const visibleCount = Math.max(0, maxVisible - 1);
  const overflowCount = memberCount - visibleCount;

  return {
    visibleCount,
    overflowCount,
  };
}
